import Cookies from "js-cookie";
import helperUtilities from "shared/mixins/helper-utilities";

/**
 * @module
 * the app is responsible for global events and
 * responsibilities.
 */

const selector = "[data-js-fjarrvarme-kalkylator-foretag]";
const fjarrvarmeKalkylatorForetag = function (el, app) {
    const $el = $(el);

    const $consumptionInput = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-cons-input]",
    );
    const consumptionInput = $consumptionInput[0];
    const $powerInput = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-power-input]",
    );
    const powerInput = $powerInput[0];
    const $rtInput = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-rt-input]",
    );

    const $displayRtCost = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-display-rt-cost]",
    );
    const $displayYearlyCost = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-display-yearly-cost]",
    );
    const $displayCostPerUnit = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-display-cost-per-unit]",
    );
    const $displayCons = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-display-cons]",
    );
    const $displayPower = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-display-power]",
    );
    const $displayPowerCost = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-display-power-cost]",
    );
    const $displayEnergyCost = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-display-energy-cost]",
    );

    const $useDefaultPower = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-use-default-power]",
    );
    const $cancelPowerChange = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-cancel-power]",
    );

    const $savePowerChange = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-save-power]",
    );
    const $changePower = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-change-power]",
    );

    const $flip = $el.find("[data-js-fjarrvarme-kalkylator-foretag-flip]");
    const flip = $flip[0];

    const $questions = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-questions]",
    );
    const questions = $questions[0];
    const $consumptionQuestion = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-consumption-question]",
    );

    const $result = $el.find("[data-js-fjarrvarme-kalkylator-foretag-result]");
    const $resultSummary = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-result-summary]",
    );
    const $resultSummaryData = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-result-summary-data]",
    );
    const $resultYear = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-result-year]",
    );
    const $resultYearChart = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-result-year-chart]",
    );
    const $resultYearDetailsTable = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-result-year-details-table]",
    );

    const $toSummary = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-show-summary]",
    );
    const $toYear = $el.find(
        "[data-js-fjarrvarme-kalkylator-foretag-show-year]",
    );
    const $report = $el.find("[data-js-fjarrvarme-kalkylator-foretag-report]");
    const chartsLoaded = $.Deferred();
    const smallScreen = $(window).width() < 1000;
    const $yearCostSmallScreen = $el.find(
        ".Ge-Fjarrvarme-KalkylatorForetag-YearCostSmallScreen",
    );
    const $loadingReport = $el.find(
        ".Ge-Fjarrvarme-KalkylatorForetag-LoadingReport",
    );
    const $reportDownloaded = $el.find(
        ".Ge-Fjarrvarme-KalkylatorForetag-ReportDownloaded",
    );

    // const powerColor = "#EAEAEA";
    const powerColor = "#951C7E";
    // const energyColors = [ "#5CA0C4", "#C5DFEC", "#EDF5F8" ];
    const energyColor = "#5CA1C4";
    // const rtColors = { minus:"#7AAD3E", plus:"#E54949" };
    const rtColor = "#79AD3E";

    const $downloadLink = $reportDownloaded.find("a");

    let ww = $(window).width();

    const utilities = helperUtilities(app);

    let yearNeedsUpdating = true;
    let yearIsVisible = false;

    let lastPowerSettings = {
        useDefault: true,
        power: undefined,
    };

    const show = function (...$elts) {
        for (var i = 0; i < $elts.length; i++) {
            $elts[i].removeClass("Ge-Hidden");
        }
    };

    const hide = function (...$elts) {
        for (var i = 0; i < $elts.length; i++) {
            $elts[i].addClass("Ge-Hidden");
        }
    };

    const init = function () {
        $(setup);
    };

    const formatValue = function (val) {
        return Math.round(val)
            .toFixed()
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    const setup = function () {
        if (smallScreen) {
            var options = {
                root: null,
                rootMargin: "0px",
                threshold: [0.9],
            };

            var observer = new IntersectionObserver(function (entries) {
                const visible = entries[0].intersectionRatio >= 0.9;
                if (visible) {
                    $yearCostSmallScreen
                        .addClass("Ge-Opaque")
                        .removeClass("Ge-Transparent");
                } else {
                    $yearCostSmallScreen
                        .addClass("Ge-Transparent")
                        .removeClass("Ge-Opaque");
                }
            }, options);

            var yearCost = $(
                "[data-js-fjarrvarme-kalkylator-foretag-yearly-cost-row]",
            )[0];

            observer.observe(yearCost);
        }

        loadCharts();

        $downloadLink.click(function (ev) {
            app.trigger("beacon", "fv-calc download-report-from-link");
        });

        $toSummary.click(function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            show($yearCostSmallScreen, $resultSummary, $toYear);
            hide($resultYear, $toSummary, $consumptionQuestion);
            $result[0].scrollIntoView(true);
            yearIsVisible = false;
            app.trigger("beacon", "fv-calc switch-to-summary");
        });

        $toYear.click(function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            hide($yearCostSmallScreen, $resultSummary, $toYear);
            show($resultYear, $toSummary, $consumptionQuestion);

            yearIsVisible = true;

            if (yearNeedsUpdating) {
                updateYear();
            }
            $result[0].scrollIntoView(true);
            app.trigger("beacon", "fv-calc switch-to-year");
        });

        $report.click(function (ev) {
            ev.preventDefault();
            ev.stopPropagation();

            const data = {
                info: getCurrentInfo(),
                params: dhParams,
                item1Name: getSelectedItem(1).name,
                item2Name: getSelectedItem(2).name,
            };
            app.trigger("beacon", "fv-calc download-report");

            show($loadingReport);
            $.post("/GeneralApi", {
                command: "Fjarrvarme-PrepareReport",
                data: JSON.stringify(data),
            }).then((r) => {
                var url = r.result.reportUrl;
                window.location.href = url;
                hide($loadingReport);
                show($reportDownloaded);

                $downloadLink.prop("href", url).text(url);
            });
        });

        $consumptionInput.on("change", function (ev) {
            updateValues();
            app.trigger(
                "beacon",
                "fv-calc changed-consumption-to:" + getConsumption(),
            );
        });
        $consumptionInput.on("changing", function (ev) {
            updateValues();
        });

        $powerInput.on("change", function (ev) {
            updateValues();
            app.trigger("beacon", "fv-calc changed-power-to:" + getPower());
        });
        $powerInput.on("changing", function (ev) {
            updateValues();
        });

        $rtInput.on("change", function (ev) {
            updateValues();
            app.trigger("beacon", "fv-calc changed-rt-to:" + getRt());
        });

        $questions
            .on("change", function (ev) {
                updateValues({ setConsumption: true });
                flip.interface.update("questions change");
            })
            .on("reopen", function (ev) {
                hide($result);
            });

        $useDefaultPower.on("change", (ev) => {
            if (useDefaultPower()) {
                hide($changePower);
                flip.interface.update("default power change");
                updateValues();
                app.trigger("beacon", "fv-calc change-to-default-power");
            } else {
                powerInput.interface.setValue(getDefaultPower());
                lastPowerSettings.useDefault = true;
                powerInput.interface.setLimits(0, getConsumption());
                $flip.trigger("flip2");
                app.trigger("beacon", "fv-calc change-to-manual-power");
            }
        });

        $changePower.on("click", (ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            lastPowerSettings.useDefault = false;
            lastPowerSettings.power = getPower();
            powerInput.interface.setLimits(0, getConsumption());
            $flip.trigger("flip2");
            app.trigger("beacon", "fv-calc flip-to-change-power");
        });

        $cancelPowerChange.on("click", (ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            restoreLastPowerSettings();
            updateValues();
            $flip.trigger("flip1");
            app.trigger("beacon", "fv-calc cancel-change-power");
        });

        $savePowerChange.on("click", (ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            $flip.trigger("flip1");
            flip.interface.update("save power change");
            updateValues();
            app.trigger("beacon", "fv-calc save-change-power");
        });

        if (consumptionInput.interface.getValue() !== "0") {
            updateValues();
        } else {
            updateValues({ setConsumption: true });
        }

        setupResize();
        flip.interface.update("initial");
    };

    const updateYear = function () {
        const info = getCurrentInfo();

        updateYearChart(info);
        updateYearDetails(info);
        yearNeedsUpdating = false;
    };

    const getTooltip = function (mnth, rt, power, consumption, total) {
        var s =
            '<div style="padding:5px;width:250px"><table style="width:100%">' +
            '<tr><td></td><td colspan="3"><b>' +
            escape(dhParams.longMonthNames[mnth]) +
            "</b></td></tr>";
        if (!isNaN(power)) {
            // var rtColor = rt > 0 ? rtColors.plus: rtColors.minus;

            s +=
                '<tr><td width="14" bgcolor="' +
                energyColor +
                '"></td><td>' +
                htmlEncode(dhParams.textEnergy) +
                '</td><td rowspan="3" style="width:10px"></td><td align="right">' +
                formatNumber(consumption) +
                " kr</td></tr>" +
                '<tr><td width="14" bgcolor="' +
                powerColor +
                '"></td><td>' +
                htmlEncode(dhParams.textPower) +
                '</td><td align="right">' +
                formatNumber(power) +
                " kr</td></tr>" +
                (rt != 0
                    ? '<tr><td width="14" bgcolor="' +
                      rtColor +
                      '"></td><td>' +
                      htmlEncode(dhParams.textRt) +
                      '</td><td align="right">' +
                      formatNumber(rt) +
                      " kr</td></tr>"
                    : "") +
                '<tr><td colspan="4"><hr /></td></tr>' +
                "<tr><td></td><td><strong>" +
                htmlEncode(dhParams.textSum) +
                '</strong></td><td></td><td align="right"><strong>' +
                formatNumber(total) +
                " kr</strong></td></tr>";
            // s += '<tr><td width="14" bgcolor="' + energyColors[getSeason(mnth)-1] + '"></td><td>' + htmlEncode(dhParams.textEnergy) + '</td><td rowspan="3" style="width:10px"></td><td align="right">' + formatNumber(consumption) + ' kr</td></tr>' +
            // '<tr><td width="14" bgcolor="' + powerColor + '"></td><td>' + htmlEncode(dhParams.textPower) + '</td><td align="right">' + formatNumber(power) + ' kr</td></tr>' +
            // (rt != 0 ? '<tr><td width="14" bgcolor="' + rtColor + '"></td><td>' + htmlEncode(dhParams.textRt) + '</td><td align="right">' + formatNumber(rt) + ' kr</td></tr>' : '' ) +
            // '<tr><td colspan="4"><hr /></td></tr>' +
            // '<tr><td></td><td><strong>' + htmlEncode(dhParams.textSum) + '</strong></td><td></td><td align="right"><strong>' + formatNumber(total) + ' kr</strong></td></tr>';
        }
        s += "</table></div>";
        return s;
    };

    const setupResize = function () {
        let resizeTimer = false;
        $(window).resize(function onResizeUnThrottled(ev) {
            // Assume window height does not affect flip heights
            // Most mobile browsers hide and show the ui-chrome when
            // scrolling and fire multiple resize events for different heights
            const w = $(window).width();

            if (w === ww) {
                return;
            }

            ww = w;

            yearNeedsUpdating = true;

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function resizeFinished() {
                if (yearIsVisible) {
                    updateYear();
                }
            }, 100);
        });
    };

    const updateYearChart = function (info) {
        if (!info.hasValues) {
            return;
        }

        const dataTable = new google.visualization.DataTable();
        dataTable.addColumn("string", "month");
        dataTable.addColumn({
            type: "string",
            role: "tooltip",
            p: { html: true },
        });
        dataTable.addColumn("number", dhParams.textRt);
        dataTable.addColumn("number", dhParams.textRt);
        dataTable.addColumn("number", dhParams.textPower);
        dataTable.addColumn("number", dhParams.textEnergy);
        dataTable.addColumn("number", dhParams.textEnergy);
        dataTable.addColumn("number", dhParams.textEnergy);

        let minRt = 0;
        for (let month = 0; month < 12; month++) {
            const rtCost = Math.round(info.rtCosts.months[month]);
            let powerCost = Math.round(info.powerCosts.months[month]);
            const consumptionCost = Math.round(
                info.consumptionCosts.months[month],
            );
            const totalCost = Math.round(info.totalCosts.months[month]);
            let consumption1 = 0;
            let consumption2 = 0;
            let consumption3 = 0;
            let rtPos = 0;
            let rtNeg = 0;
            if (rtCost > 0) {
                rtPos = rtCost;
            } else {
                rtNeg = rtCost;
            }

            switch (getSeason(month)) {
                case 1:
                    consumption1 = consumptionCost;
                    break;
                case 2:
                    consumption2 = consumptionCost;
                    break;
                case 3:
                    consumption3 = consumptionCost;
                    break;
            }

            const tooltip = getTooltip(
                month,
                rtCost,
                powerCost,
                consumptionCost,
                totalCost,
            );

            // Adjust power after tooltip
            if (rtNeg != 0) {
                powerCost += rtNeg;
            }

            dataTable.addRow([
                dhParams.shortMonthNames[month],
                tooltip,
                rtPos,
                rtNeg,
                powerCost,
                consumption1,
                consumption2,
                consumption3,
            ]);

            if (rtCost < minRt) {
                minRt = rtCost;
            }
        }

        var options = {
            tooltip: { isHtml: true },
            legend: { position: "none" },
            bar: {
                groupWidth: "90%",
                color: { stroke: "#000", strokeWidth: "2" },
            },
            chartArea: {
                left: smallScreen ? "15%" : 100,
                top: 20,
                width: smallScreen ? "83%" : "80%",
                height: "85%",
            },
            isStacked: true,
            // series: [{ color: rtColors.plus }, { color: rtColors.minus }, { color: powerColor }, { color: energyColors[0] }, { color: energyColors[1] }, { color: energyColors[2]}],
            series: [
                { color: rtColor },
                { color: rtColor },
                { color: powerColor },
                { color: energyColor },
                { color: energyColor },
                { color: energyColor },
            ],
            vAxis: {
                gridlines: { count: 7, color: "#eeeeee" },
                viewWindow: { min: minRt, max: "automatic" },
            },
            focusTarget: "category",
        };
        var chart = new google.visualization.ColumnChart(
            $resultYearChart.get(0),
        );
        chart.draw(dataTable, options);
    };

    const getSeason = function (month) {
        switch (month) {
            case 0:
            case 1:
            case 2:
            case 11:
                return 1;
            case 3:
            case 9:
            case 10:
                return 2;
            default:
                return 3;
        }
    };

    const htmlEncode = function (value) {
        return $("<div/>").text(value).html();
    };

    const formatNumber = function (val) {
        return Math.round(val)
            .toFixed()
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    const loadCharts = function () {
        google.load("visualization", "1", {
            packages: ["corechart"],
            callback: function () {
                chartsLoaded.resolve();
            },
        });
    };

    const useDefaultPower = function () {
        return $useDefaultPower.prop("checked");
    };

    const restoreLastPowerSettings = function () {
        if (lastPowerSettings.useDefault) {
            $useDefaultPower.prop("checked", true);
        } else {
            powerInput.interface.setValue(lastPowerSettings.power);
        }
    };

    const updateValues = function (options) {
        yearNeedsUpdating = true;
        hide($reportDownloaded);
        const item = getSelectedItem(2);

        if (item === undefined) {
            hide($result);
            return;
        }

        if (options && options.setConsumption === true) {
            consumptionInput.interface.setValue(item.defaultConsumption);
            $useDefaultPower.prop("checked", true);
        }

        const info = getCurrentInfo();

        $changePower.toggleClass("Ge-Hidden", useDefaultPower());
        show($result);

        if (info.hasValues) {
            $displayYearlyCost.text(formatValue(info.totalCosts.total));
            $displayCostPerUnit.text(
                formatValue(
                    info.consumption
                        ? info.totalCosts.total / info.consumption
                        : 0,
                ),
            );
            $displayRtCost.text(formatValue(info.rtCosts.total));
            $displayEnergyCost.text(formatValue(info.consumptionCosts.total));
            $displayPowerCost.text(formatValue(info.powerCosts.total));
            $displayPower.text(formatValue(info.power));
            $displayCons.text(formatValue(info.consumption));

            Cookies.set(getCookieName("Consumption"), info.consumption, {
                expires: app.cookieLong,
            });
            Cookies.set(getCookieName("Power"), info.power, {
                expires: app.cookieLong,
            });
            Cookies.set(
                getCookieName("UseDefaultPower"),
                useDefaultPower() ? "1" : "0",
                { expires: app.cookieLong },
            );
            Cookies.set(getCookieName("ReturnTemp"), info.rt, {
                expires: app.cookieLong,
            });
        } else {
            $yearlyCost.text("---");
        }
    };

    const getCookieName = function (inputName) {
        return utilities.getAppName() + inputName;
    };

    const updateYearDetails = function (info) {
        var $rows = $resultYearDetailsTable.find("tr");
        for (var i = 0; i < 12; i++) {
            var $mTr = $rows.eq(i + 1);
            var $mCells = $mTr.children("td");
            $mCells.eq(0).text(formatNumber(info.consumptionCosts.months[i]));
            $mCells.eq(1).text(formatNumber(info.powerCosts.months[i]));
            $mCells.eq(2).text(formatNumber(info.rtCosts.months[i]));
            $mCells.eq(3).text(formatNumber(info.totalCosts.months[i]));
            $mCells.eq(4).text(formatNumber(info.consumptionMonths.months[i]));
        }

        const $totalTr = $rows.eq(13);
        const $totalCells = $totalTr.children("td");

        $totalCells.eq(0).text(formatNumber(info.consumptionCosts.total));
        $totalCells.eq(1).text(formatNumber(info.powerCosts.total));
        $totalCells.eq(2).text(formatNumber(info.rtCosts.total));
        $totalCells.eq(3).text(formatNumber(info.totalCosts.total));

        // Use the exact input consumption instead of info.consumptionMonths.total (nicer rounding)
        $totalCells.eq(4).text(formatNumber(info.consumption));
    };

    const getConsumption = function () {
        const v = consumptionInput.interface.getValue();
        return parseInt(v, 10);
    };

    const getDefaultPower = function () {
        const cons = getConsumption();
        const factor = getSelectedItem(2).defaultPowerFactor;
        return Math.round(cons / factor);
    };

    const getPower = function () {
        if (useDefaultPower()) {
            return getDefaultPower();
        } else {
            const v = powerInput.interface.getValue();
            return parseInt(v, 10);
        }
    };

    const getPowerCost = function (powerPrices, power) {
        if (power < 50) return powerPrices.below50;
        if (power < 100) return powerPrices.below100;
        if (power < 250) return powerPrices.below250;
        if (power < 500) return powerPrices.below500;
        if (power < 1000) return powerPrices.below1000;
        if (power < 2500) return powerPrices.below2500;

        return powerPrices.above2500;
    };

    const getPowerCosts = function (power, item) {
        let result = { total: 0, months: [] };
        for (var i = 0; i < 12; i++) {
            const daysInMonth = getDaysInMonth(i, new Date().getYear());
            const fixed = getPowerCost(item.fixedPowerPrices, power);
            const variable = getPowerCost(item.variablePowerPrices, power);
            const v = ((fixed + power * variable) * daysInMonth) / 365;
            result.total += v;
            result.months.push(v);
        }
        return result;
    };

    const getDaysInMonth = function (m, year) {
        var isLeap = year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
        switch (m + 1) {
            case 1:
                return 31;
            case 2:
                return isLeap ? 29 : 28;
            case 3:
                return 31;
            case 4:
                return 30;
            case 5:
                return 31;
            case 6:
                return 30;
            case 7:
                return 31;
            case 8:
                return 31;
            case 9:
                return 30;
            case 10:
                return 31;
            case 11:
                return 30;
            case 12:
                return 31;
            default:
                return -1;
        }
    };

    const getCurrentInfo = function () {
        const cons = getConsumption();
        const power = getPower();
        const rt = getRt();

        const item = getSelectedItem(2);

        if (item === undefined) {
            return {
                hasItem: false,
            };
        }

        const consumptionMonths = getConsumptionMonths(cons, item);
        const consumptionCosts = getConsumptionCosts(cons, item);
        const powerCosts = getPowerCosts(power, item);
        const rtCosts = getRtCosts(cons, item, rt);
        const totalCosts = combine([consumptionCosts, powerCosts, rtCosts]);

        return {
            hasItem: true,
            hasValues: !isNaN(cons) && !isNaN(power) && !isNaN(rt),
            consumption: cons,
            power: power,
            rt: rt,
            item: item,
            consumptionMonths: consumptionMonths,
            consumptionCosts: consumptionCosts,
            powerCosts: powerCosts,
            rtCosts: rtCosts,
            totalCosts: totalCosts,
        };
    };

    const currRootItem = function () {
        return dhParams.rootItem;
    };

    const getItemById = function (parentItem, id) {
        let matchItem;
        $.each(parentItem.subItems, function (_, item) {
            if (item.id === id) {
                matchItem = item;
                return false;
            }
        });
        return matchItem;
    };

    const getSelectedItem = function (level) {
        const selected = questions.interface.getValue();

        if (selected.length < level) {
            return undefined;
        }

        const level1Item = getItemById(currRootItem(), selected[0].answer);

        if (level === 1) return level1Item;

        return getItemById(level1Item, selected[1].answer);
    };

    const getMonthConsumption = function (consumption, item, month) {
        return (consumption * item.consumptionDistribution[month]) / 100;
    };

    const getConsumptionMonths = function (consumption, item) {
        let result = { total: 0, months: [] };
        for (var i = 0; i < 12; i++) {
            const v = getMonthConsumption(consumption, item, i);
            result.total += v;
            result.months.push(v);
        }
        return result;
    };

    const getConsumptionCosts = function (consumption, item) {
        let result = { total: 0, months: [] };
        for (var i = 0; i < 12; i++) {
            const v =
                item.seasonPrices[i] *
                getMonthConsumption(consumption, item, i);
            result.total += v;
            result.months.push(v);
        }
        return result;
    };

    const getRtCosts = function (consumption, item, rt) {
        let result = { total: 0, months: [] };
        for (var i = 0; i < 12; i++) {
            var v =
                (item.rtPrices[i] *
                    rt *
                    consumption *
                    item.consumptionDistribution[i]) /
                100;
            result.total += v;
            result.months.push(v);
        }
        return result;
    };

    const getRt = function () {
        return parseInt($rtInput.val(), 10);
    };

    const combine = function (lists) {
        let result = { total: 0, months: [] };
        for (var m = 0; m < 12; m++) {
            let v = 0;
            for (var i = 0; i < lists.length; i++) {
                v += lists[i].months[m];
            }
            result.total += v;
            result.months.push(v);
        }
        return result;
    };

    return {
        init: init(),
    };
};

fjarrvarmeKalkylatorForetag.selector = selector;

export default fjarrvarmeKalkylatorForetag;
